import React, { useEffect, useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
import { Col, Row, Modal, ModalHeader, ModalBody, Alert } from "reactstrap";
import FormCheckbox from "../../form-components/CheckboxComponent";
import usersApis from "../../../api/master/users";
import { Button, Icon } from "../../../components/Component";
import { set } from "date-fns";
import rolesApi from "../../../api/master/roles";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import UserAccessibilityModal from "../Users/UserAccessibilityModal";

interface Module {
  name: string;
  label: string;
}

const modules: Module[] = [
  { name: "Masters", label: "Masters" },
  { name: "Dashboard", label: "Dashboard" },
  { name: "ProcureToPay", label: "Procure to Pay" },
  { name: "Inventory", label: "Inventory" },
  { name: "Reports", label: "Reports" },
];

const NewAccessibility: React.FC = (props: any) => {
  const navigate = useNavigate();
  const methods = useForm({
    mode: "onChange",
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    reset,
  } = useFormContext();
  const [formData, setFormData] = useState({
    accessibility: [],
  });
  const [alertInfo, setAlertInfo] = useState({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedModule, setSelectedModule] = useState<string | null>(null);
  const [accessibilityData, setAccessibilityData] = useState<any>();

  const formWatch = watch();

  const [accessibilityModalData, setAccessibilityModalData] = useState<any[]>(
    []
  );
  const toggleModal = () => {
    setModalOpen((prev) => {
      if (prev) {
        setSelectedModule(null); // Clear selected module on close
      }
      return !prev;
    });
  };

  const openGrantAccessModal = (moduleName: string) => {
    const latestAccessibility = getValues("accessibility") || [];
    console.log("latestAccessibility", latestAccessibility);
    setAccessibilityModalData(latestAccessibility);
    setSelectedModule(moduleName);
    setModalOpen(true);
  };

  const fetchModuleConfig = async () => {
    try {
      const res = await usersApis.getModuleConfig();
      const data = res.data;
      setAccessibilityData({ accessibility: data });
      data.forEach((module: any) => {
        const key = module.category.toLowerCase(); // e.g., "Masters" => "masters"
        if (modules.some((m) => m.name === key)) {
          setValue(key, true); // set checkbox as checked
        }
      });
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    const formAccessibility = getValues("accessibility");
    if (!formAccessibility || formAccessibility.length === 0) {
      fetchModuleConfig();
    }
  }, []);

  const formatAccessibilityData = (accessibility: any) => {
    const formattedModules = accessibility.flatMap((entry: any) => {
      // Case 1: "Reports" - nested categories inside modules
      if (entry.category === "Reports") {
        return entry.modules.flatMap((subCat: any) =>
          subCat.modules.map((mod: any) => ({
            module: String(mod.moduleID),
            add: !!mod.actions?.add,
            view: !!mod.actions?.view,
            edit: !!mod.actions?.edit,
            cancel: !!mod.actions?.cancel,
            approve: !!mod.actions?.approve,
            reject: !!mod.actions?.reject,
          }))
        );
      }

      // Case 2: Normal categories
      return entry.modules.map((mod: any) => ({
        module: String(mod.moduleID),
        add: !!mod.actions?.add,
        view: !!mod.actions?.view,
        edit: !!mod.actions?.edit,
        cancel: !!mod.actions?.cancel,
        approve: !!mod.actions?.approve,
        reject: !!mod.actions?.reject,
      }));
    });
    return formattedModules;
  };

  useEffect(() => {
    if (
      accessibilityData &&
      (!getValues("accessibility") || getValues("accessibility").length === 0)
    ) {
      console.log("useEffect::data.accessibility", accessibilityData);
      setValue("accessibility", accessibilityData);
    }
  }, [accessibilityData]);

  const submitForm = (formData: any) => {
    console.log("SUBMIT:::data", formData);
    console.log("data", formData, getValues("accessibility"));
    const moduleKeys = [
      "Dashboard",
      "Inventory",
      "Masters",
      "ProcureToPay",
      "Reports",
    ];

    const allAccessibilities = getValues("accessibility")?.accessibility || [];
    const filteredAccessibilities = allAccessibilities.filter(
      (item: any) => formData[item.category] === true
    );
    console.log("allAccessibilities", allAccessibilities);
    const allFalse = moduleKeys.every((key) => formData[key] === false);

    if (allFalse) {
      setAlertInfo({
        type: "error",
        message: "Please select at least one module accessibility",
        errors: [],
      });
      return;
    }
    if (alertInfo.message) {
      setTimeout(() => {
        setAlertInfo({ type: "", message: "", errors: [] }); // or setAlertInfo({}) based on how you reset it
      }, 10000);
    }

    console.log("Filtered Accessibilities:", filteredAccessibilities);
    const formdat = formatAccessibilityData(filteredAccessibilities);
    console.log("formdat", formdat);
    formData.accessibility = formdat;
    console.log("formdata", formData);
    createRole(formData);
  };

  const createRole = async (data: any) => {
    const response = await rolesApi.createRole(data);
    const { status, message } = response;
    if (status) {
      Swal.fire("Created!", "Role has been created", "success");
      navigate(`/roles`);
    } else {
      let errorMessage = "An error occurred";
      const fullErrorMessage = `${errorMessage}\n${message.join(", ")}`;
      setAlertInfo({
        type: "error",
        message: fullErrorMessage,
        errors: [],
      });
    }
  };

  return (
    <>
      {alertInfo.message && (
        <div className="mb-3 mt-1">
          <Alert
            color={alertInfo.type === "error" ? "danger" : "success"}
            className="alert-icon"
          >
            <strong>{alertInfo.message}</strong>
            <Icon
              name={
                alertInfo.type === "error" ? "alert-circle" : "check-circle"
              }
            />
            {alertInfo.errors.length > 0 ? (
              <ul>
                {alertInfo.errors.map((err: any, index: any) => (
                  <li key={index}>{err}</li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </Alert>
        </div>
      )}
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="12">
            <div className="form-group">
              <label className="form-label">Accessibility</label>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
              >
                {modules.map(({ name, label }) => (
                  <div key={name} className="data-col align-center pt-1 ">
                    <div className="data-label w-45">
                      <FormCheckbox
                        name={name}
                        optionLabel={label}
                        required
                        onChange={(e: any) => {
                          setValue(name, e.target.checked);
                        }}
                      />
                    </div>
                    <div className="data-value w-55 ">
                      {watch(name) && (
                        <a
                          href="#"
                          className="ml-3"
                          onClick={(e) => {
                            e.preventDefault();
                            openGrantAccessModal(name);
                          }}
                          style={{ fontSize: 14, color: "#6576ff" }}
                        >
                          Grant Access
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit">
                Submit Form
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={props.prev}
                className="btn-dim btn btn-secondary"
              >
                Previous
              </Button>
            </li>
          </ul>
        </div>
      </form>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          Grant Access – {selectedModule}
        </ModalHeader>
        <ModalBody>
          <UserAccessibilityModal
            selectedViewDetailsName={selectedModule}
            data={accessibilityModalData}
            onSave={(data: any) => {
              console.log("data}}}", data);
              setAccessibilityData(data);
              setModalOpen(false);
              setValue("accessibility", data);
            }}
            onCancel={() => {
              toggleModal();
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default NewAccessibility;
